(function(angular){
	'use strict';

	angular
		.module('unemploymentComparisonChartModule')
		.directive('unemploymentComparisonChart', [
			'Highcharts', 
			'HIGHCHARTS_OPTIONS', 
			'STATIC_BASE_PATH', 
			unemploymentComparisonChartFunction
		]);

	function unemploymentComparisonChartFunction(Highcharts, HIGHCHARTS_OPTIONS, STATIC_BASE_PATH) {
		return {
			template: '<div id="unemployment-comparison-chart" class="is-active coterminous"></div>',
			restrict: 'E',
			replace: true,
			scope: {},
			link: function($scope, $element, $attrs) {

				Highcharts.setOptions(HIGHCHARTS_OPTIONS());
				
				var chart = new Highcharts.Chart({
					chart: {
						renderTo: 'unemployment-comparison-chart'	
					},
					series: [{
						color: '#F47735',
						data: [3.1, 3.1, 3.1, 3.2, 3.4, 3.5, 3.7, 3.8, 4, 4.1, 4.4, 4.7, 5.1, 5.4, 5.6, 5.7, 5.9, 6, 6, 6.1, 6.3, 6.3, 6.4, 6.5, 6.6, 6.7, 6.7, 6.5, 6.4, 6.3, 6.2, 6.2, 6.1, 6.1, 6.2, 6.2, 6.1, 6.1, 6.1, 6.2, 6.2, 6.2, 6.2, 6.2, 6.2, 6.1, 6, 6, 6, 6, 5.9, 5.9, 5.9, 5.9, 5.8, 5.7, 5.6, 5.6, 5.6, 5.7, 5.7, 5.6, 5.6, 5.6, 5.7, 5.7, 5.6, 5.5, 5.4, 5.4, 5.3, 5.2, 5.2, 5.3, 5.3, 5.2, 5.1, 5.1, 5.2, 5.2, 5, 4.9, 4.9, 4.8, 4.8, 4.7, 4.6, 4.6, 4.6, 4.5, 4.3, 4.3, 4.2, 4.2, 4.2, 4, 3.9, 3.9, 3.9, 3.9, 3.9, 3.9, 3.9, 3.9, 4, 4, 3.9, 3.9, 3.8, 3.8, 3.8, 3.8, 3.7, 3.7, 3.7, 3.7, 3.6, 3.6, 3.6, 3.6, 3.6],
						name: 'Washington, DC MSA',
						marker: {
							symbol: 'circle'
						},
						pointIntervalUnit: 'month',
						pointStart: Date.UTC(2008, 0, 1)
					},{
						color: '#878C92',
						data: [5, 4.9, 5.1, 5, 5.4, 5.6, 5.8, 6.1, 6.1, 6.5, 6.8, 7.3, 7.8, 8.3, 8.7, 9, 9.4, 9.5, 9.5, 9.6, 9.8, 10, 9.9, 9.9, 9.8, 9.8, 9.9, 9.9, 9.6, 9.4, 9.4, 9.5, 9.5, 9.4, 9.8, 9.3, 9.1, 9, 9, 9.1, 9, 9.1, 9, 9, 9, 8.8, 8.6, 8.5, 8.3, 8.3, 8.2, 8.2, 8.2, 8.2, 8.2, 8.1, 7.8, 7.8, 7.7, 7.9, 8, 7.7, 7.5, 7.6, 7.5, 7.5, 7.3, 7.2, 7.2, 7.2, 6.9, 6.7, 6.6, 6.7, 6.7, 6.3, 6.3, 6.1, 6.2, 6.2, 5.9, 5.7, 5.8, 5.6, 5.7, 5.5, 5.5, 5.4, 5.5, 5.3, 5.2, 5.1, 5, 5, 5, 5, 4.9, 4.9, 5, 5, 4.7, 4.9, 4.9, 4.9, 5, 4.9, 4.6, 4.7, 4.8, 4.7, 4.5, 4.4, 4.3, 4.3, 4.3, 4.4, 4.2, 4.1, 4.1, 4.1, 4.1],
						name: 'National Average',
						marker: {
							symbol: 'circle'
						},
						pointIntervalUnit: 'month',
						pointStart: Date.UTC(2008, 0, 1)
					}],
					xAxis: {
						type: 'datetime'
					},
					yAxis: {
						labels: {
							formatter: function() {
								return this.value + '%';
							}
						},
						max: 10
					}
				});
				
			}
		};
	}
})(window.angular);